export enum RemoteFeatureFlagStatus {
  Error = 'error',
  False = 'false',
  NotFound = 'notFound',
  True = 'true',
  Value = 'value',
}
